/* eslint-disable */
export default {
  init() {
    // check window width
    var getWidth = function () {
      var width;
      if (document.body && document.body.offsetWidth) {
        width = document.body.offsetWidth;
      }
      if (document.compatMode === 'CSS1Compat' && document.documentElement && document.documentElement.offsetWidth) {
        width = document.documentElement.offsetWidth;
      }
      if (window.innerWidth) {
        width = window.innerWidth;
      }
      return width;
    };

    window.onload = function () {
      getWidth();
    };

    window.onresize = function () {
      getWidth();
    };

    // On filter item change, add height to map feed so footer doesn't overlay filter
    $('.c-filter-item__input, .c-filter-item').bind('click change', function () {
      var height = $('.c-filter__items').height() - 200;
      $('.c-map__feed').css('min-height', height);
    });

    // Smooth scrolling on anchor clicks
    $('a[href*="#"]:not([href="#"])').click(function () {
      if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top - 40
          }, 1000);
          return false;
        }
      }
    });

    // Close assistance message and set cookie
    $('.c-assist-block__close-btn').click(function (e) {
      e.preventDefault();
      document.cookie = 'alert=hide; Path=/';
      $('.c-assist-block').fadeOut();
    });

    // Check if alert cookie exists
    if (document.cookie.split(';').filter(function (item) {
      return item.trim().indexOf('alert=') == 0;
    }).length) {
      $('.c-assist-block').hide();
    } else {
      $('.c-assist-block').show();
    }

    // Prev and next anchor links for multiple items
    $('.js-anchor-item').first().addClass('is-active');

    $('.js-next').click(function (e) {
      var selected = $('.js-anchor-item.is-active');
      var anchors = $('.js-anchor-item');

      var pos = anchors.index(selected);
      var next = anchors.get(pos + 1);
      var prev = anchors.get(pos - 1);

      var target = $(next);

      $(selected).removeClass('is-active');
      $(next).addClass('is-active');

      if (target.offset()) {
        $('html, body').animate({ scrollTop: target.offset().top - 40 }, 600);
      }

      e.preventDefault();
    });

    $('.js-prev').click(function (e) {
      var selected = $('.js-anchor-item.is-active');
      var anchors = $('.js-anchor-item');

      var pos = anchors.index(selected);
      var next = anchors.get(pos + 1);
      var prev = anchors.get(pos - 1);

      var target = $(prev);

      $(selected).removeClass('is-active');
      $(prev).addClass('is-active');

      if (target.offset()) {
        $('html, body').animate({ scrollTop: target.offset().top - 40 }, 600);
      }

      e.preventDefault();
    });

    // Remove class from all filter items except this
    $('.c-filter-item').on('click', function () {
      var item = $(this);
      $('.c-filter-item').not(item).removeClass('this-is-active');
      // $(this).siblings('.c-filter-item').children().removeClass('this-is-active');
      // $(this).toggleClass('this-is-active');
      // $(this).children().toggleClass('this-is-active');
    });

    // Remove active class on body click
    $(document).click(function (e) {
      if ($(e.target).closest('.c-filter-item').length === 0) {
        $('.c-filter-item, .c-filter-item__toggle').removeClass('this-is-active');
      }
    });

    if (getWidth() >= 700) {
      // Remove class after 10s
      setTimeout(function () {
        $('.c-filter-item').removeClass('this-is-active');
      }, 10000);
    }

    // Add active class to parent if child has active class
    $('.c-sidebar-subnav__link.is-active').parent().parent().parent().addClass('is-active');

    // Remove active menu classes if click on the main body
    $('.l-content').not('.c-primary-nav').click(function () {
      $('.c-header, .c-header__toggle').removeClass('this-is-active');
    });

    // JavaScript to be fired on all pages
    var $toggled = '';
    var toggleClasses = function (element) {
      var $this = element,
          $togglePrefix = $this.data('prefix') || 'this';

      // If the element you need toggled is relative to the toggle, add the
      // .js-this class to the parent element and "this" to the data-toggled attr.
      if ($this.data('toggled') === 'this') {
        $toggled = $this.parents('.js-this');
      } else {
        $toggled = $('.' + $this.data('toggled'));
      }

      $this.toggleClass($togglePrefix + '-is-active');
      $toggled.toggleClass($togglePrefix + '-is-active');

      // Remove a class on another element, if needed.
      if ($this.data('remove')) {
        $('.' + $this.data('remove')).removeClass($this.data('remove'));
      }
    };

    /*
     * Toggle Active Classes
     *
     * @description:
     *  toggle specific classes based on data-attr of clicked element
     *
     * @requires:
     *  'js-toggle' class and a data-attr with the element to be
     *  toggled's class name both applied to the clicked element
     *
     * @example usage:
     *  <span class="js-toggle" data-toggled="toggled-class">Toggler</span>
     *  <div class="toggled-class">This element's class will be toggled</div>
     *
     */
    $('.js-toggle').on('click', function (e) {
      e.stopPropagation();
      toggleClasses($(this));
    });

    // Toggle parent class
    $('.js-toggle-parent').on('click', function (e) {
      e.preventDefault();
      var $this = $(this);

      $this.parent().toggleClass('this-is-active');
    });

    // Toggle hovered classes
    $('.js-hover').on('mouseenter mouseleave', function (e) {
      e.preventDefault();
      toggleClasses($(this));
    });

    $('.js-hover-parent').on('mouseenter mouseleave', function (e) {
      e.preventDefault();
      toggleClasses($(this).parent());
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  }
};


// WEBPACK FOOTER //
// ./scripts/routes/common.js